package example.shadcn_kotlin.ui.pages.docs.components

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import example.shadcn_kotlin.ui.components.*
import example.shadcn_kotlin.ui.pages.components.demo.SelectDemo

@Page
@Composable
fun SelectPage() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("docs/components/select.md", mapOf("title" to listOf("Select"), "description" to listOf("Displays a list of options for the user to pick from—triggered by a button."), "radix" to listOf(), "link" to listOf("https://www.radix-ui.com/docs/primitives/components/select"), "api" to listOf("https://www.radix-ui.com/docs/primitives/components/select#api-reference")))) {
        example.shadcn_kotlin.ui.components.layouts.MDLayout {
            ComponentPreview("""import react.FC
import react.Props
import react.ReactNode
import shadcn.ui.components.*
import web.cssom.ClassName

val SelectDemo = FC<Props> {
    Select {
        SelectTrigger {
            className = ClassName("w-[180px]")
            SelectValue {
                placeholder = ReactNode("Select a fruit")
            }
        }
        SelectContent {
            SelectGroup {
                SelectLabel { +"Fruits" }
                SelectItem {
                    value = "apple"
                    +"Apple"
                }
                SelectItem {
                    value = "banana"
                    +"Banana"
                }
                SelectItem {
                    value = "blueberry"
                    +"Blueberry"
                }
                SelectItem {
                    value = "grapes"
                    +"Grapes"
                }
                SelectItem {
                    value = "pineapple"
                    +"Pineapple"
                }
            }
        }
    }
}"""){ 
 SelectDemo {} 
 }
            org.jetbrains.compose.web.dom.H2({ 
classes("font-heading","mt-12","scroll-m-20","border-b","pb-2","text-2xl","font-semibold","tracking-tight","first:mt-0")
id("usage")
 }) {
                org.jetbrains.compose.web.dom.Text("Usage")
            }
            CodeBlock("""import shadcn.ui.components.Select
import shadcn.ui.components.SelectContent
import shadcn.ui.components.SelectItem
import shadcn.ui.components.SelectTrigger
import shadcn.ui.components.SelectValue
""", lang= "kotlin", highlight= "")
            CodeBlock("""Select {
    SelectTrigger {
        className = ClassName("w-[180px]")
        SelectValue { placeholder = "Theme" }
    }
    SelectContent {
        SelectItem {
            value = "light"
            +"Light"
        }
        SelectItem {
            value = "dark"
            +"Dark"
        }
        SelectItem {
            value = "system"
            +"System"
        }
    }
}
""", lang= "kotlin", highlight= "")
        }
    }
}
